import {apiUserLink} from "@pg-mono/rp-api-routes";
import type {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {selectIsUserAuthenticated} from "../utils/select_is_user_authenticated";

export interface IHomeMatchConfiguration {
    is_active: boolean;
}

export interface IHomeMatchConfigurationPayload {
    is_active: boolean;
    source_section: HomeMatchConfigurationSourceSection;
}

export const patchHomeMatchConfigurationApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomeMatchConfiguration: builder.query<IHomeMatchConfiguration | null, void>({
            queryFn: async (_arg, queryApi, _extraOptions, baseQuery) => {
                const isAuthenticated = selectIsUserAuthenticated(queryApi.getState() as IRootState);

                if (!isAuthenticated) {
                    return {data: null};
                }

                const result = await baseQuery({
                    url: apiUserLink.homeMatch.configuration,
                    method: "GET"
                });

                if (result.error) {
                    return {
                        error: getIgnoredNotifyResponse(result.error, [401, 403, 404])
                    };
                }

                return {data: result.data as IHomeMatchConfiguration};
            },
            providesTags: ["HomeMatchConfiguration"]
        }),
        patchHomeMatchConfiguration: builder.mutation<unknown, IHomeMatchConfigurationPayload>({
            query: (body) => ({
                url: apiUserLink.homeMatch.configuration,
                method: "PUT",
                body
            }),
            invalidatesTags: ["HomeMatchConfiguration"]
        })
    }),
    overrideExisting: false
});

export const {useGetHomeMatchConfigurationQuery, usePatchHomeMatchConfigurationMutation} = patchHomeMatchConfigurationApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";
import type {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {rpApi} from "../../app/api/rp_api";
import {IRootState} from "../../store/store";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {selectIsUserAuthenticated} from "../utils/select_is_user_authenticated";

export interface IHomeMatchConfiguration {
    is_active: boolean;
}

export interface IHomeMatchConfigurationPayload {
    is_active: boolean;
    source_section: HomeMatchConfigurationSourceSection;
}

export const patchHomeMatchConfigurationApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomeMatchConfiguration: builder.query<IHomeMatchConfiguration | null, void>({
            queryFn: async (_arg, queryApi, _extraOptions, baseQuery) => {
                const isAuthenticated = selectIsUserAuthenticated(queryApi.getState() as IRootState);

                if (!isAuthenticated) {
                    return {data: null};
                }

                const result = await baseQuery({
                    url: apiUserLink.homeMatch.configuration,
                    method: "GET"
                });

                if (result.error) {
                    return {
                        error: getIgnoredNotifyResponse(result.error, [401, 403, 404])
                    };
                }

                return {data: result.data as IHomeMatchConfiguration};
            },
            providesTags: ["HomeMatchConfiguration"]
        }),
        patchHomeMatchConfiguration: builder.mutation<unknown, IHomeMatchConfigurationPayload>({
            query: (body) => ({
                url: apiUserLink.homeMatch.configuration,
                method: "PUT",
                body
            }),
            invalidatesTags: ["HomeMatchConfiguration"]
        })
    }),
    overrideExisting: false
});

export const {useGetHomeMatchConfigurationQuery, usePatchHomeMatchConfigurationMutation} = patchHomeMatchConfigurationApi;
